export const hasUserPermission = (userPermissions, permission) => {
    return userPermissions?.find((p) => p.code_key == permission) ? true : false
}

export const hasUserPermissionOnMegaMenuGroupItem = (userPermissions, obj) => obj.map((x) => x.permission).map((permission) => hasUserPermission(userPermissions, permission)).includes(true)

export const hasUserPermissionOnNavMenuItem = (userPermissions, ...megaNavGroup) => {
    // loope through the arguments and check if the user has permission
    for (let i = 0; i < megaNavGroup.length; i++) {
        if (hasUserPermissionOnMegaMenuGroupItem(userPermissions, megaNavGroup[i])) {
            return true
        }
    }
    return false
}
